export const SET_SIMPLE_PAGAMENTO_DIRETO_STATE_ACTION = '@pagamentoDireto/SET_SIMPLE_PAGAMENTO_DIRETO_STATE_ACTION';
export const SET_SIMPLE_CONTROLS_STEP_STATE_ACTION = '@pagamentoDireto/SET_CONTROLS_STEP_STATE_ACTION ';
export const PESQUISAR_INFO_PROCESSO = '@pagamentoDireto/PESQUISAR_INFO_PROCESSO';
export const BUSCAR_LISTA_PROCESSOS_REQUISICAO_PAGTO_DIRETO = '@pagamentoDireto/BUSCAR_LISTA_PROCESSOS_REQUISICAO_PAGTO_DIRETO';
export const SET_PASSO_UM_DATA_ACTION = '@pagamentoDireto/SET_PASSO_UM_DATA_ACTION';
export const SET_PASSO_UM_CONTROLS_ACTION = '@pagamentoDireto/SET_PASSO_UM_CONTROLS_ACTION';
export const SET_NUM_PROCESSO_ACTION = '@pagamentoDireto/SET_NUM_PROCESSO_ACTION';
export const SET_LISTA_PROCESSOS_ACTION = '@pagamentoDireto/SET_LISTA_PROCESSOS_ACTION';
